import { Text, Box, Columns, Column, Stack } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import CalculatorSvg from 'src/images/calculator.svg';
import ScreeningSvg from 'src/images/screening.svg';
import WriteSvg from 'src/images/write.svg';

import { CustomHeading } from './CustomHeading';
import { GetAccessButton } from './GetAccessButton';

export const ExitStrategy = () => {
  const contents = [
    {
      title: 'Guide to selling a business',
      image: WriteSvg,
    },
    {
      title: 'Business value calculator',
      image: CalculatorSvg,
    },
    {
      title: 'Buyer screening guide',
      image: ScreeningSvg,
    },
  ];

  return (
    <Box>
      <Stack space="medium">
        <Box textAlign="center">
          <CustomHeading semanticLevel="h2" mobileLevel="1" tabletLevel="2">
            Prepare your exit strategy
          </CustomHeading>
        </Box>
        <Box paddingX={['none', 'none', 'xxlarge']}>
          <Text tone="secondary" align="center">
            Register with SEEK Business to access exclusive seller resources.
            Because we know selling a business is a complex process and more
            than just posting an ad.
          </Text>
        </Box>
      </Stack>

      <Box paddingTop="large">
        <Columns space="xlarge" collapseBelow="tablet">
          {contents.map((c, index) => (
            <Column key={index}>
              <Box
                display="flex"
                height="full"
                justifyContent="spaceBetween"
                flexDirection="column"
                alignItems="center"
              >
                <Stack space="xsmall" align="center">
                  <CustomSvg svg={c.image} />
                  <Box marginTop="small">
                    <CustomHeading
                      semanticLevel="h3"
                      mobileLevel="2"
                      tabletLevel="3"
                    >
                      {c.title}
                    </CustomHeading>
                  </Box>
                </Stack>
                <GetAccessButton />
              </Box>
            </Column>
          ))}
        </Columns>
      </Box>
    </Box>
  );
};
